import { gql } from "generated-graphql";

export const FACILITIES_BY_GENERATOR_STATUS_AND_STATE_QUERY = gql(`
    query WasteFacilitiesByGeneratorStatusAndState($tenantId: String!, $filter: WasteOverviewFilter!) {
      wasteFacilitiesByGeneratorStatusAndState(tenantId: $tenantId, filter: $filter) {
        state
        generatorStatus
        count
      }
    }
  `);

export const WASTE_TOTAL_WASTE_QUERY = gql(`
    query WasteTotalWaste($tenantId: String!, $filter: WasteOverviewFilter!) {
      wasteTotalWaste(tenantId: $tenantId, filter: $filter) {
        wasteByClassification {
          classification
          totalAmountInPounds
          percentage
        }
        periodPercentChange
        previousPeriodTotal
      }
    }
  `);

export const TSDF_TOTAL_QUANTITY_QUERY = gql(/* GraphQL */ `
  query TotalQuantityByTsdf(
    $tenantId: String!
    $maxResults: Int
    $filter: WasteOverviewFilter!
  ) {
    totalQuantityByTsdf(
      tenantId: $tenantId
      maxResults: $maxResults
      filter: $filter
    ) {
      items {
        destinationFacilityId
        destinationFacilityName
        totalQuantityLbs
      }
      count
      totalQuantityLbs
    }
  }
`);
export const WASTE_VENDOR_TOTALS_QUERY = gql(`
    query WasteVendorTotals($tenantId: String!, $filter: WasteOverviewFilter!, $limit: Int) {
      wasteVendorTotals(tenantId: $tenantId, filter: $filter, limit: $limit) {
        manifestSource
        totalQuantityPounds
      }
    }
  `);

export const MANAGEMENT_METHOD_QUERY = gql(`
    query WasteManagementMethod($tenantId: String!, $filter: WasteOverviewFilter!, $limit: Int) {
      wasteManagementMethod(tenantId: $tenantId, filter: $filter, limit: $limit) {
        managementMethodCode
        managementMethodDescription
        totalQuantityPounds
      }
    }
  `);
